import React, { Fragment, useContext, useEffect, useMemo, useState, useRef, useCallback } from "react";
import styles from './index.module.scss'
import logoPng from '../../assets/img/logo.png'
import avtorPng from '../../assets/img/avtor.png'
import { Button, Dropdown, message, notification, Modal, Popover, ConfigProvider, Input, Badge } from 'antd'
import { DownOutlined, CaretDownOutlined, SearchOutlined, UpOutlined, RightOutlined, CloseOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd'
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import MainContext from '../../stores/stores'
import { useIntl } from 'react-intl'
import VinInput from "../../components/VinInput"
import orderApi from '../../api/orderApi'
import accountApi from "../../api/accountApi";
import lang_china from '../../assets/img/lang_china.png'
import lang_hk from '../../assets/img/lang_hk.png'
import lang_en from '../../assets/img/lang_en.png'
import lang_ru from '../../assets/img/lang_ru.png'
import lang_tr from '../../assets/img/lang_tr.png'

import { useAliveController } from 'react-activation'

import { useStateContext } from "@/YXUIKit/im-kit-ui/src";
import { observer } from 'mobx-react'
import Carsearch from '@/pages/Carsearch'
import { strEncrypt, getDecryptParams, getDecryptParamsKey } from '@/utils/utils'
import vinApi from "@/api/epcApi";
import listApi from "@/api/listApi";
import IMChat from '@/pages/IMChat'
import ExportinOe from "@/components/ExportinOe";

import HeaderComponent from './HeaderComponent'
import PurchaseAsstModal from '@/pages/List/components/Modals/PurchaseAsstModal'
// import { PurchaseAsst } from '@/pages/List/PidList'

const Header: React.FC<any> = () => {
  const token = localStorage.getItem("token") || ''
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  let params = searchParams.get("params")
  const intl = useIntl()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, pageType, logo, isWomala, host, colorPrimary, fontColorPrimary, canLang, isCst, distributorInfo, hasFreeVin, sxSetData  } = commonStore
  const [longer, setLonger] = useState<boolean>(true)
  let domain = window.location.host
  
  const [allNav, setAllNav] = useState<any[]>([])
  const [standardNav, setStandardNav] = useState<any[]>([])
  const [moreNav, setMoreNav] = useState<any[]>([])

  const [brandOpen, setBrandOpen] = useState<boolean>(false)
  const [carInfo, setCarInfo] = useState<any>({})

  const [centerItems, setCenterItems] = useState<any[]>([])
  const [vinInputKey, setVinInputKey] = useState<string>('')

  const [classShow, setClassShow] = useState<boolean>(false)
  const [hasSecondClass, setHasSecondClass] = useState<boolean>(false)
  const [parts_categories_zone, set_parts_categories_zone] = useState<any[]>([])
  const [classImg, setClassImg] = useState<any>({})
  const [classList, setClassList] = useState<any[]>([])
  const [groupClass, setGroupClass] = useState<any>({})
  const [selClass, setSelClass] = useState<string>("")
  const [secondClass, setSecondClass] = useState<string>("")
  const [oeKeyword, setOeKeyword] = useState<string>('')
  const [historyShow, setHistoryShow] = useState<boolean>(false)
  const [oeHistory, setOeHistory] = useState<any[]>([])
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const [selTags, setSelTags] = useState<string>('')
  const [selHeaderClass, setSelHeaderClass] = useState<string>('')
  const [asstShow, setAsstShow] = useState<boolean>(false)
  const [asstInfo, setAsstInfo] = useState<any>({})
	
	const istest: number = window.location.host.includes("webtest") || window.location.host.includes("localhost:300") ? 1 : 0
	const isXts: boolean = window.location.host.includes("xts.") || window.location.host.includes("webtest.") || window.location.host.includes("localhost:300")
  const isHm: boolean = window.location.host.includes("gzhmqy.")
  const modalRef = useRef<any>(null);
  const buttonRef = useRef<any>(null);

  // 点击外部区域关闭弹窗的逻辑
  useEffect(() => {
    if(pageType === '6' || pageType === '7') {
      const handleClickOutside = (event: any) => {
        // 检查点击是否发生在弹窗或按钮之外
        if (
          modalRef.current && 
          !modalRef.current.contains(event.target) && 
          buttonRef.current && 
          !buttonRef.current.contains(event.target)
        ) {
          setClassShow(false);
        }
      };

      if (classShow && pathname !== '/home') {
        // 在捕获阶段添加事件监听，避免冒泡问题
        document.addEventListener('click', handleClickOutside, true);
      }

      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
    
  }, [classShow, pageType]);

  useEffect(() => {
    if(pageType === '7') {
      if(pathname === '/home' && commonStore.headerInfo && commonStore.headerInfo.dropdown_checked) {
        setClassShow(true)
      }else {
        setClassShow(false)
      }
    }
  }, [pathname, pageType, commonStore.headerInfo])

  useEffect(() => {
    getPartCateZone()
    getSecondClass()
    getNavgation()
    if(token && (!localStorage.getItem('tourist_user'))) {
      getCartList()
      // getOeHistory()
    }
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
    // if ("geolocation" in navigator) {
    //   navigator.geolocation.getCurrentPosition(
    //     function(position) {
    //       console.log("Latitude is :", position.coords.latitude);
    //       console.log("Longitude is :", position.coords.longitude);
    //     },
    //     function(error) {
    //       console.error("Error Code = " + error.code + " - " + error.message);
    //     }
    //   );
    //   navigator.geolocation.watchPosition(
    //     function(position) {
    //       console.log("Latitude is :", position.coords.latitude);
    //       console.log("Longitude is :", position.coords.longitude);
    //     },
    //     function(err) {
    //       console.log(22,err)
    //     }
    //   )
    // } else {
    //   console.error("Geolocation is not supported by this browser.");
    // }
  },[])

  useEffect(() => {
    // if((commonStore.pageType === '5' || commonStore.pageType === '6') && pathname === '/cjh') {
    if((commonStore.pageType === '5' || commonStore.pageType === '6' || commonStore.pageType === '7' || commonStore.pageType === '8' || commonStore.pageType === '9' || commonStore.pageType === '10') && (pathname === '/cjh' || pathname === '/oe')) {
      if(params) {
        let paramsObj = getDecryptParams(params)
        if(paramsObj.vin) {
          setVinInputKey(paramsObj.vin)
        }else if(paramsObj.brand && !paramsObj.vin) {
          setVinInputKey(paramsObj.brand)
        }else if(paramsObj.en_plate) {
          setVinInputKey(paramsObj.en_plate)
        }else if(paramsObj.oeList) {
          setVinInputKey(paramsObj.oeList)
        }else {
          setVinInputKey('')
        }
      }else {
        setVinInputKey('')
      }
    }
    // if((commonStore.pageType === '6' || commonStore.pageType === '7') && pathname === '/cjh') {
    if(pathname === '/cjh') {
      // setOeKeyword('')
      if(params) {
        let paramsObj = getDecryptParams(params)
        console.log("paramsObj666:", paramsObj)
        if(paramsObj.class) {
          let _classArr = paramsObj.class.split(',')
          let class1 = _classArr[0].replace(/\+/, "&")
          let class2 = _classArr[1] ? _classArr[1].replace(/\+/, "&") : ''
          setSelTags('')
          setSelHeaderClass('')
          setSelClass(class1)
          setSecondClass(class2)
        }else {
          setSelClass('')
          setSecondClass('')
        }
        if(paramsObj.tags) {
          setSelClass('')
          setSecondClass('')
          setSelTags(paramsObj.tags)
          if(parts_categories_zone.length) {
            let index = parts_categories_zone.findIndex((ele: any) => paramsObj.tags && ele.config && ele.config.tags && ele.config.tags === paramsObj.tags)
            if(index !== -1) {
              let _parts_categories_zone_item = parts_categories_zone[index]
              setSelHeaderClass(_parts_categories_zone_item.name)
            }
          }
        }else {
          setSelTags('')
          setSelHeaderClass('')
        }
        if(paramsObj.partKeyword) {
          setOeKeyword(paramsObj.partKeyword)
        }
      }else {
        setSelClass('')
        setSecondClass('')
        setOeKeyword('')
        setSelTags('')
        setSelHeaderClass('')
      }
    }
    if(commonStore.pageType === '6' && pathname === '/oe') {
      const search = window.location.search
      let _params = getDecryptParamsKey(search, 'params')
      let paramsObj = _params ? getDecryptParams(_params) : {oeList: '', class: ''}
      if(paramsObj.class) {
        let _classArr = paramsObj.class.split(',')
        let class1 = _classArr[0].replace(/\+/, "&")
        let class2 = _classArr[1] ? _classArr[1].replace(/\+/, "&") : ''
        setSelClass(class1)
        setSecondClass(class2)
        setSelTags('')
        setSelHeaderClass('')
      }else {
        setSelClass('')
        setSecondClass('')
      }
      /* setSelClass('')
      setSecondClass('')
      setSelTags('')
      setSelHeaderClass('') */
      let _oeList = paramsObj.oeList ? paramsObj.oeList.split(",") : []
      if(_oeList.length) {
        setOeKeyword(_oeList.join(','))
      }else {
        setOeKeyword('')
      }
    }
  }, [pathname, commonStore.pageType, params, parts_categories_zone])

  useEffect(() => {
    const lang: any  = window.localStorage.getItem('lang')
    if(pageType !== '6' && pageType !== '5') {
      if(lang === 'zh' || lang === 'cht') {
        if(document.body.clientWidth <= 1420) {
          setLonger(false)
        }else if(document.body.clientWidth <= 1800) {
          if((standardNav.length + moreNav.length) <= 8) {
            setLonger(true)
          }else {
            setLonger(false)
          }
        }else {
          setLonger(true)
        }
      }else {
        if(document.body.clientWidth <= 1800) {
          setLonger(false)
        }else if(document.body.clientWidth <= 2400) {
          if((standardNav.length + moreNav.length) <= 10) {
            setLonger(true)
          }else {
            setLonger(false)
          }
        }else {
          setLonger(true)
        }
      }
      if((standardNav.length + moreNav.length) <= 6) {
        setLonger(true)
      }
    }else {
      if(lang === 'zh' || lang === 'cht') {
        if(document.body.clientWidth <= 1420) {
          setLonger(false)
        }else if(document.body.clientWidth <= 1800) {
          if((standardNav.length + moreNav.length) <= 9) {
            setLonger(true)
          }else {
            setLonger(false)
          }
        }else {
          setLonger(true)
        }
      }else {
        if(document.body.clientWidth <= 1420) {
          setLonger(false)
        }else if(document.body.clientWidth <= 1800) {
          if((standardNav.length + moreNav.length) <= 9) {
            setLonger(true)
          }else {
            setLonger(false)
          }
        }else {
          setLonger(true)
        }
      }
      if((standardNav.length + moreNav.length) <= 6) {
        setLonger(true)
      }
    }
    
  },[standardNav, moreNav, pageType])
  
	useEffect(() => {
    let companyItems = commonStore.userInfo && commonStore.userInfo.is_repair_shop_admin ? [
      {
        key: '/mine/company',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/company')}>
            <i className="iconfont icon-a-Vector1 mr5"></i>
            {intl.formatMessage({ id: '公司管理' })}
          </div>
        )
      },
    ] : []
    const _items: any = commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? [
      {
        key: '/mine/aftersales',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/aftersales')}>
            <i className="iconfont icon-tuikuanshouhou mr5"></i>
            {intl.formatMessage({id: '退款/售后'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/reconciliation',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/reconciliation')}>
            <i className="iconfont icon-duizhangdan mr5"></i>
            {intl.formatMessage({id: '对账单'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/copewith',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/copewith')}>
            <i className="iconfont icon-yingfudan mr5"></i>
            {intl.formatMessage({id: '应付单'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/address',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/address')}>
            <i className="iconfont icon-dizhiguanli mr5"></i>
            {intl.formatMessage({id: '地址管理'})}
          </div>
        )
      },
      {
        key: '/mine/invoice',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/invoice')}>
            <i className="iconfont icon-fapiaotaitou mr5"></i>
            {intl.formatMessage({id: '发票抬头'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        key: '/mine/setting',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/setting')}>
            <i className="iconfont icon-shezhi mr5"></i>
            {intl.formatMessage({id: '设置'})}
          </div>
        )
      },
      {
        key: 'logout',
        label: (
          <div className="flex-s-c" onClick={logout}>
            <i className="iconfont icon-tuichudenglu1 mr5"></i>
            {intl.formatMessage({id: '退出登录'})}
          </div>
        )
      }
    ] : [
      {
        key: '/mine/address',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/address')}>
            <i className="iconfont icon-dizhiguanli mr5"></i>
            {intl.formatMessage({id: '地址管理'})}
          </div>
        )
      },
      {
        key: '/mine/invoice',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/invoice')}>
            <i className="iconfont icon-fapiaotaitou mr5"></i>
            {intl.formatMessage({id: '发票抬头'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        key: '/mine/setting',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/setting')}>
            <i className="iconfont icon-shezhi mr5"></i>
            {intl.formatMessage({id: '设置'})}
          </div>
        )
      },
      {
        key: 'logout',
        label: (
          <div className="flex-s-c" onClick={logout}>
            <i className="iconfont icon-tuichudenglu1 mr5"></i>
            {intl.formatMessage({id: '退出登录'})}
          </div>
        )
      }
    ]
    if(pageType === '8') {
      _items.unshift({
        key: '/mine/order',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/order')}>
            <i className="iconfont icon-wodedingdan mr5" />
            {intl.formatMessage({id: '我的订单'})}
          </div>
        )
      })
    }
    setCenterItems(_items)
  }, [commonStore.userInfo, commonStore.distributorInfo, pageType])

	const priceUnit = useMemo(() => {
    let _unit: string = ''
    if(commonStore.currency_data) {
      if(commonStore.currency_data.unit) {
        _unit = commonStore.currency_data.unit
      }else if(commonStore.currency_data.code) {
        _unit = commonStore.currency_data.code + '  '
      }
    }
    return _unit ? _unit : ''
  }, [commonStore.currency_data])
  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }
  
  const getNavgation = () => {
    accountApi.getNavgationNew({ domain: host || domain }).then((res: any) => {
      if(res.code === 1) {
        let navData = res.data
        let _allNav: any[] = []
        let cjhIndex = navData.findIndex((ele: any) => ele.path === '/cjh')
        let cjhItem = cjhIndex > -1 ? navData[cjhIndex] : {}
        let oeIndex = navData.findIndex((ele: any) => ele.path === '/oe')
        let oeItem = oeIndex > -1 ? navData[oeIndex] : {}
        navData.forEach((ele: any) => {
          if((ele.path === '/vin' || ele.path === '/cjh' || ele.path === '/carsearch') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/cjh')
            if(index === -1) {
              _allNav.push({
                path: '/cjh',
                is_add: 0,
                is_check: 1,
                name: cjhItem.name ? cjhItem.name : intl.formatMessage({id: '车架号查询'}),
                icon: ''
              })
            }
          }else if((ele.path === '/code' || ele.path === '/oe') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/oe')
            if(index === -1) {
              _allNav.push({
                path: '/oe',
                is_add: 0,
                is_check: 1,
                name: oeItem.name ? oeItem.name : intl.formatMessage({id: '零件号查询'}),
                icon: 'icon-lingjianchaxun'
              })
            }
          }else if(ele.is_add && ele.is_check) {
            ele.path = `/morepage/${ele.code}`
            _allNav.push(ele)
          }else if(ele.is_check) {
            if(ele.path === '/epc') {
              ele.icon = 'icon-EPCchaxun'
            }else if(ele.path === '/enquery') {
              ele.icon = 'icon-fabuxunjia'
            }
            _allNav.push(ele)
          }
        })
        let _standardNav = _allNav.filter((item: any, index: number) => index === 0 || (!item.is_add && item.is_check && item.path !== '/engine'))
        let _moreNav = _allNav.filter((item: any, index: number) => {
          if(item.is_add && item.is_check && index !== 0) {
            item.path = `/morepage/${item.code}`
            return true
          }
        })
        if(pageType === '7' || pageType === '6') {
          let filterStdNav = _standardNav.filter((ele: any) => ele.path !== '/cjh' && ele.path !== '/oe')
          if(filterStdNav.length < 4) {
            let lastIndexLen = 4 - filterStdNav.length
            let otherStandardNav = _moreNav.slice(0, lastIndexLen)
            _standardNav = [..._standardNav, ...otherStandardNav]
            _moreNav = _moreNav.slice(lastIndexLen)
          }
        }else if(pageType === '5') {
          let filterStdNav = _standardNav.filter((ele: any) => ele.path !== '/cjh')
          if(filterStdNav.length < 4) {
            let lastIndexLen = 4 - filterStdNav.length
            let otherStandardNav = _moreNav.slice(0, lastIndexLen)
            _standardNav = [..._standardNav, ...otherStandardNav]
            _moreNav = _moreNav.slice(lastIndexLen)
          }
        }else {
          let filterStdNav = _standardNav
          if(filterStdNav.length < 4) {
            let lastIndexLen = 4 - filterStdNav.length
            let otherStandardNav = _moreNav.slice(0, lastIndexLen)
            _standardNav = [..._standardNav, ...otherStandardNav]
            _moreNav = _moreNav.slice(lastIndexLen)
          }
        }
        let _homeUrl = _allNav[0] && _allNav[0].path ? _allNav[0].path : ''
        // console.log("homeUrl:", _homeUrl)
        setCommonStore({
          type: 'homeUrl',
          value: _homeUrl
        })
        console.log("_standardNav:", _standardNav)
        console.log("_moreNav:", _moreNav)
        console.log("_allNav:", _allNav)
        // setStandardNav(_standardNav)
        setAllNav(_allNav)
        setStandardNav(_standardNav)
        setMoreNav(_moreNav)
      }
    })
  }
  const getOeHistory = () => {
    vinApi.getHistory({
      query_type: 'oe_query',
      page: 1,
      size: 10
    }).then((res: any) => {
      if(res.code === 1) {
        let _data = res.data && res.data.data ? res.data.data : []
        setOeHistory(_data)
      }
    })
  }

  const showMore = useMemo<any>(() => {
    if(isWomala || moreNav.length) {
      return [
        {
          name: intl.formatMessage({ id: '更多' }),
          key: 'more'
        }
      ]
    }else {
      return []
    }
  },[moreNav])

  const getPartCateZone = () => {
    let domain = window.location.host
    const lang: any  = window.localStorage.getItem('lang')
    accountApi.getHomeDataThree({ 
      domain: host || domain,
      lang 
    }).then((res: any) => {
      setCommonStore({
        type: 'isGetFreeCjh',
        value: true
      })
      if(res.code === 1) {
        let _parts_categories_zone = res.data && res.data.parts_categories_zone ? res.data.parts_categories_zone : []
        set_parts_categories_zone(_parts_categories_zone)
        if(params) {
          let paramsObj = getDecryptParams(params)
          let tags = paramsObj.tags ? paramsObj.tags : ''
          let index = _parts_categories_zone.findIndex((ele: any) => tags && ele.config && ele.config.tags && ele.config.tags === tags)
          if(index !== -1) {
            let _parts_categories_zone_item = _parts_categories_zone[index]
            setSelHeaderClass(_parts_categories_zone_item.name)
          }
        }
        let dataVin = res.data && res.data.vin ? res.data.vin : []
        let contract2 = res.data && res.data.contract2 ? res.data.contract2 : {}
        if(lang) {
          let item = contract2[lang] ? contract2[lang] : {}
          setCommonStore({ value: item, type: 'webData' })
        }
        setCommonStore({ value: dataVin.length ? true : false, type: 'hasFreeVin'})
        setCommonStore({ value: res.data.name, type: 'siteName' })
        setCommonStore({
          value: dataVin,
          type: 'freeCjhList'
        })
        setCommonStore({
          value: res.data && res.data.epc_brands ? res.data.epc_brands : {},
          type: 'epc_barnds'
        })
      }
    })
  }
  const getSecondClass = () => {
    accountApi.getSecondClass({
      is_hide: 1
    }).then((res: any) => {
      if(res.code === 1) {
        let images_dict = res.data && res.data.images_dict ? res.data.images_dict : {}
        let standard_maingroup = res.data && res.data.standard_maingroup ? res.data.standard_maingroup : []
        setClassImg(images_dict)
        setClassList(standard_maingroup)
        if(Object.keys(res.data.standard_subgroup_name).length) setHasSecondClass(true)
        setGroupClass(res.data.standard_subgroup_name)
      }
    })
  }
  const classItems: any[] = useMemo(() => {
    if(classList.length > 6) {
      let _classItems = classList.slice(6).map((item: any, index: number) => {
        return {
          label: <div className='pointer' onClick={() => classItemClick(item, index + 7)}>{item}</div>,
          value: item
        }
      })
      return _classItems
    }else {
      return []
    }
  }, [classList, hasSecondClass])
  const getCartList = () => {
    orderApi.getCartList().then((res: any) => {
      if(res.code === 1) {
        let _data = res.data
        let length = 0
        let price = 0
        let goods_code_list: any = []
        Object.keys(_data).forEach((items: string) => {
          Object.keys(_data[items].goods_list).forEach((item: string) => {
            length += 1
            _data[items].goods_list[item].selected = true
            if(_data[items].goods_list[item].stock_type === 'epc'){
              const d = _data[items].goods_list[item].data
              const basic = d.basic
              const supportBuy = d.supportBuy
              if(basic && supportBuy){
                if(basic.pic && basic.pic.length){
                  _data[items].goods_list[item].images = basic.pic[0].pic
                }else {
                  _data[items].goods_list[item].images = d.detail.img || ''
                }
                _data[items].goods_list[item].part_name = basic.label
                _data[items].goods_list[item].quality_name = intl.formatMessage({id: '大库原厂'})
                _data[items].goods_list[item].quality_oe = supportBuy.pid
                if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                  _data[items].goods_list[item]['4s_price'] = supportBuy.DMS.price / 100
                }
                _data[items].goods_list[item].quality_price = supportBuy.DMS.purchase_price / 100
                if(supportBuy.DMS.purchase_price) {
                  price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                }
                
              }
            }else if(_data[items].goods_list[item].stock_type === 'yc'){
              const info = _data[items].goods_list[item].data
              _data[items].goods_list[item].images = info.img || info.detail.img || ''
              _data[items].goods_list[item].part_name = info.part_name
              _data[items].goods_list[item].quality_name = intl.formatMessage({id: '原厂'})
              _data[items].goods_list[item].quality_oe = info.oe
              if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                _data[items].goods_list[item]['4s_price'] = info.price_4s
              }
            }else {
              goods_code_list.push({
                code: item,
                goods_cst_id: _data[items].goods_list[item].goods_cst_id,
                brandCode: _data[items].goods_list[item].data ? _data[items].goods_list[item].data.brandcode : ''
              })
            }
            
          })
        })
        if(goods_code_list.length > 0) {
          listApi.getAllGoods({
            goods_codes: goods_code_list
          }).then((res1: any) => {
            if(res1.code === 1) {
              let _data1 = res1.data
              Object.keys(_data).forEach((items: string) => {
                Object.keys(_data[items].goods_list).forEach((item: string) => {
                  if(_data[items].goods_list[item].stock_type !== 'epc' && _data[items].goods_list[item].stock_type !== 'yc'){
                    try{
                      _data[items].goods_list[item] = {
                        ..._data[items].goods_list[item],
                        ..._data1[_data[items].goods_list[item].goods_cst_id][item]
                      }
                      if(_data[items].goods_list[item].quality_price) {
                        price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                      }
                    }catch(err) {
                      console.info(err)
                    }
                  }
                })
              })
            }
            setCommonStore({
              type: 'cartPrice',
              value: parseFloat(price.toFixed(2))
            })
          }).catch((err: any) => {
            setCommonStore({
              type: 'cartPrice',
              value: parseFloat(price.toFixed(2))
            })
          })
        }else {
          setCommonStore({
            type: 'cartPrice',
            value: parseFloat(price.toFixed(2))
          })
        }
        setCommonStore({
          type: 'cartNum',
          value: length 
        })
      }
    })
  }
  const goToUrl = (item: any) => {
    let is_must = item.is_must
    /* if(!is_must && item.is_add === 0 && ((commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status))) {
      message.warning(intl.formatMessage({ id: "暂无权限" }))
      return false
    } */
    /* if(item.path === '/enquery') {
      navigate("/login")
      return false
    } */
    let url = item.path
		
		if(url) {
			try {
				clear()
			}catch(err: any) {
				
			}
			setTimeout(() => {
        if(window.location.host.includes("partsbond") && url === '/epc') {
          if(window.localStorage.getItem("lang") === 'ru') {
            window.open('https://ru.partsbond.com',"__blank")
          }else {
            window.open('https://partsbond.com',"__blank")
          }
          // if(window.location.host.includes("partsbond")) {
          //   if(window.localStorage.getItem("lang") === 'ru') {
          //     window.open('https://ru.partsbond.com',"__blank")
          //   }else {
          //     window.open('https://partsbond.com',"__blank")
          //   }
          // }else {
          //   window.open("https://multilingual.xiaomaiqipei.com", "__blank")
          // }
        }else {
          if(url === '/enquery' || url.includes('/epc')) {
            if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
              navigate(url)
            }else {
              message.warning(intl.formatMessage({ id: "请先登录" }))
              toGo('/login')
            }
          }else {
            navigate(url)
          }
        }
			},100)
			return false
		}
  }
  const toGo = (url: string) => {
    navigate(url)
  }

  const goMore = (item: any) => {
    navigate(item.path)
    // if(item.is_add) {
    //   navigate(`/morepage?key=${item.name}`)
    // }else {
    //   navigate(item.path)
    // }
  }

  const checkUrl = () => {
    if(token && (!localStorage.getItem('tourist_user'))) {
      if(commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1) {
        toGo('/mine/order')
      }else {
        toGo('/mine/setting')
      }
      
    }else {
      toGo('/login')
    }
  }
  const goToMain = () => {
    if(commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1) {
      toGo('/mine/order')
    }else {
      toGo('/mine/setting')
    }
  }
	
	const cateIconClick = () => {
    if(pathname === '/home') {
      setSelClass('')
      setSecondClass('')
      setSelTags('')
      setSelHeaderClass('')
    }
    setClassShow(!classShow)
  }
	const openNew = () => {
		window.open("/merchant/order/list", "__blank")
	}
  const linkArr = [
    ...standardNav,
    ...showMore
  ]
  
  // 
  const moreArr: any = isWomala ? [
    {
      name: intl.formatMessage({ id: '关于我们' }),
      path: '/aboutus',
      code: 'about_us',
      icon: 'icon-guanyuwomen'
    },
    {
      name: intl.formatMessage({ id: '联系我们' }),
      path: '/contactus',
      code: 'contract_us',
      icon: 'icon-lianxiwomen'
    },
    {
      name: intl.formatMessage({ id: '疑问解答' }),
      path: '/doubt',
      code: 'faq',
      icon: 'icon-yiwenjieda'
    },
    {
      name: intl.formatMessage({ id: '购买流程' }),
      path: '/buypath',
      code: 'purchase_process',
      icon: ''
    },
  ]: moreNav

  let _nowItem = moreArr.filter((item: any) => item.path === pathname)[0]

  const setLang = (lang: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra" | "kor") => {
    setSearchParams({})
    window.localStorage.setItem('lang', lang)
    window.location.href = "/home"
  }
  const toCenterUrl = (url: string) => {
    navigate(url)
  }
  const logout = () => {
    accountApi.logout().then((res: any) => {
      if(res.code === 1) {
        localStorage.removeItem("token")
        localStorage.removeItem("ycid")
        localStorage.removeItem("openid")
        window.location.href = '/home'
      }
    })
  }
  // const capitalizeFirstLetter = (string: string) => {
  //   if(string === string.toUpperCase()) {
  //     return string
  //   }else {
  //     return string.toLowerCase().replace(/\b(\w)/g, (match, p1) => p1.toUpperCase())
  //   }
  // }
  const capitalizeFirstLetter = (string: string) => {
    if(localStorage.getItem('lang') === 'en' && string) {
      return string.split(' ').map((word: string) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    }else {
      return string
    }
  }
  const delSelClass = (e: any) => {
    e.stopPropagation()
    setSelClass('')
    setSecondClass('')
    try {
      clear()
    }catch(err: any) {
      
    }
    let params1 = searchParams.get('params')
    let paramsObj: any = {}
    if(params1) {
      paramsObj = getDecryptParams(params1)
    }
    paramsObj.class = ''
    let _searchParams = strEncrypt(paramsObj)
    if(pathname === '/cjh' || pathname === '/oe' || pathname === '/home') {
      setSearchParams({
        params: _searchParams
      })
    }
  }
  const classItemClick = (item: any, index: number) => {
    if(hasSecondClass) {
      if(selClass === item) {
        setSelTags('')
        setSelHeaderClass('')
        setSelClass('')
      }else {
        setSelTags('')
        setSelHeaderClass('')
        setSelClass(item); 
      }
      let navPath: any = document.getElementById(`navPath${index + 1}`)
      navPath?.scrollIntoView({ behavior: 'smooth' });
    }else {
      if(token) {
        if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
          message.warning(intl.formatMessage({ id: "暂无权限" }))
          return false
        }
        
        try {
          clear()
        }catch(err: any) {
          
        }
        let params1 = searchParams.get('params')
        let paramsObj: any = {}
        if(params1) {
          paramsObj = getDecryptParams(params1)
        }
        paramsObj.class = item
        if(paramsObj.tags) {
          setSelTags('')
          setSelHeaderClass('')
          delete paramsObj.tags
        }
        let _searchParams = strEncrypt(paramsObj)
        setTimeout(() => {
          navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
        },100)
      }else {
        message.warning(intl.formatMessage({ id: "请先登录" }))
        navigate('/login')
      }
    }
    
  }
  const gotoClass = (item: any) => {
    if(token) {
      if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
        message.warning(intl.formatMessage({ id: "暂无权限" }))
        return false
      }
      
      try {
        clear()
      }catch(err: any) {
        
      }
      let params1 = searchParams.get('params')
      let paramsObj: any = {}
      if(params1) {
        paramsObj = getDecryptParams(params1)
      }
      paramsObj.class = item.title
      if(paramsObj.tags) {
        setSelTags('')
        setSelHeaderClass('')
        delete paramsObj.tags
      }
      let _searchParams = strEncrypt(paramsObj)
      setTimeout(() => {
        // navigate(`/class?params=${strEncrypt({class: item.title})}`)
        navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
      },100)
    }else {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
    }
    setClassShow(false)
  }
  const gotoTagClass = (item: any) => {
    if(token) {
      if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
        message.warning(intl.formatMessage({ id: "暂无权限" }))
        return false
      }
      try {
        clear()
      }catch(err: any) {
        
      }
      let params1 = searchParams.get('params')
      let paramsObj: any = {}
      if(params1) {
        paramsObj = getDecryptParams(params1)
      }
      let tags = item.config && item.config.tags ? item.config.tags : ''
      if(tags) {
        setSelClass('')
        setSecondClass('')
        paramsObj.tags = tags
      }
      if(paramsObj.class) {
        delete paramsObj.class
      }
      setSelHeaderClass(item.name)
      setSelTags(tags)
      let _searchParams = strEncrypt(paramsObj)
      setTimeout(() => {
        // navigate(`/class?params=${strEncrypt({class: item.title})}`)
        navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
      },100)
    }else {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
    }
  }
  const inputChange = (e: any) => {
    let value = e.target.value
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.brand || paramsObj.en_plate || (pathname === '/cjh' && paramsObj.class)) {
        value = value.replace(/,/g, '')
      }
    }
    setOeKeyword(value)
    if(value.length > 0) {
      setHistoryShow(false)
    }else {
      setHistoryShow(true)
      if(commonStore.pageType === '6' && pathname === '/cjh') {
      // setOeKeyword('')
        if(params) {
          let paramsObj = getDecryptParams(params)
          if(paramsObj.partKeyword) {
            delete paramsObj.partKeyword
          }
          setSearchParams({
            params: strEncrypt(paramsObj)
          })
        }
      }else {
        setSearchParams({
          params: ''
        })
      }
      setTimeout(() => {
        clear()
      })
    }
  }
  const inputClear = () => {
    setOeKeyword('')
    let params1 = searchParams.get('params')
    if(params1) {
      let paramsObj = getDecryptParams(params1)
      if(paramsObj.brand || paramsObj.en_plate || paramsObj.class) {
        paramsObj.partKeyword = ''
        try {
          clear()
        }catch(err: any) {
          
        }
        let _searchParams = strEncrypt(paramsObj)
        setTimeout(() => {
          navigate(`/cjh?params=${_searchParams}&oekey=${new Date().getTime()}`)
        },100)  
      }else {
        try {
          clear()
        }catch(err: any) {
          
        }
        setTimeout(() => {
          navigate(`/oe?oekey=${new Date().getTime()}`)
        },100)  
      }
    }else {
      try {
        clear()
      }catch(err: any) {
        
      }
      setTimeout(() => {
        navigate(`/oe?oekey=${new Date().getTime()}`)
      },100)  
    }
  }
  const searchOeInput = (value: string) => {
    let val = value
    if(val === ''){
      return false
    }
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.brand || paramsObj.en_plate) {
        paramsObj.partKeyword = val
        try {
          clear()
        }catch(err: any) {
          
        }
        let _searchParams = strEncrypt(paramsObj)
        setTimeout(() => {
          navigate(`/cjh?params=${_searchParams}&oekey=${new Date().getTime()}`)
        },100)  
      }else {
        toOePage(val)
      }
    }else {
      toOePage(val)
    }
  }
  const toOePage = (val: string) => {
    let isEnVal = /[\u4e00-\u9fa5]/.test(val)
    if(!isEnVal && val.length < 5) {
      message.warning(intl.formatMessage({id: '至少输入5位字符'}))
      return false
    }
    if(isEnVal && val.length < 2) {
      message.warning(intl.formatMessage({id: '至少输入2位字符'}))
      return false
    }
    let _oeList = val.split(',').join(',')
    let _class = selClass + `${secondClass ? ',' + secondClass : ''}`
    let _class2 = _class.replace(/\&/, "+")
    let _searchParams = strEncrypt({
      oeList: _oeList,
      class: _class2,
      partKeyword: val.split(',') && val.split(',')[0] ? val.split(',')[0] : ''
    })
    vinApi.setHistory({
      brandCode: '',
      keyword: _oeList,
      query_type: 'oe_query'
    }).then((res2: any) => {
      if(res2.code === 1) {
        
      }
    })
    try {
      clear()
    }catch(err: any) {
      
    }
    setTimeout(() => {
      navigate(`/oe?params=${_searchParams}&oekey=${new Date().getTime()}`)
    },100)
  }
  const inputFocus = () => {
    if(!oeKeyword) {
      setHistoryShow(true)
    }else {
      setHistoryShow(false)
    }
  }
  const inputBlur = () => {
    let timer = setTimeout(() => {
      setHistoryShow(false)
      clearTimeout(timer)
    }, 300)
    
  }
  const oeItemClick = (item: any) => {
    let _keyword = item.keyword
    let _oeList = _keyword.split(",")
    setOeKeyword(_keyword)
    let _class = selClass + `${secondClass ? ',' + secondClass : ''}`
    let _class2 = _class.replace(/\&/, "+")
    let _searchParams = strEncrypt({
      oeList: _oeList.join(','),
      class: _class2,
      partKeyword: _oeList && _oeList[0] ? _oeList[0] : ''
    })
    setSearchParams({
      params: _searchParams
    })
    try {
      clear()
    }catch(err: any) {
      
    }
    setTimeout(() => {
      navigate(`/oe?params=${_searchParams}&oekey=${new Date().getTime()}`)
    },100)
    
  }
  const toHistoryMore = () => {
    navigate('/partHistoryList')
  }
  const langItems: any = [
    {
      key: 'zh',
      label: (
        <div className="flex-s-c" onClick={() => setLang('zh')}>
          中文
        </div>
      ),
      logo: lang_china
    },
    {
      key: 'en',
      label: (
        <div className="flex-s-c" onClick={() => setLang('en')}>
          English
        </div>
      ),
      logo: lang_en
    },
    {
      key: 'ru',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ru')}>
          Русский язык
        </div>
      ),
      logo: lang_ru
    },
    {
      key: 'fra',
      label: (
        <div className="flex-s-c" onClick={() => setLang('fra')}>
          French
        </div>
      )
    },
    {
      key: 'cht',
      label: (
        <div className="flex-s-c" onClick={() => setLang('cht')}>
        中文-繁體
        </div>
      ),
      logo: lang_hk
    },
    {
      key: 'tr',
      label: (
        <div className="flex-s-c" onClick={() => setLang('tr')}>
        Türkiye
        </div>
      ),
      logo: lang_tr
    },
    {
      key: 'ara',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ara')}>
          بالعربية
        </div>
      )
    },
    {
      key: 'pt',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pt')}>
          Português
        </div>
      )
    },
    {
      key: 'vie',
      label: (
        <div className="flex-s-c" onClick={() => setLang('vie')}>
          Tiếng Việt
        </div>
      )
    },
    {
      key: 'kor',
      label: (
        <div className="flex-s-c" onClick={() => setLang('kor')}>
          한국어
        </div>
      )
    },
    /* {
      key: 'may',
      label: (
        <div className="flex-s-c" onClick={() => setLang('may')}>
          Bahasa Melayu
        </div>
      )
    },
    {
      key: 'th',
      label: (
        <div className="flex-s-c" onClick={() => setLang('th')}>
          ภาษาไทย
        </div>
      )
    },
    {
      key: 'id',
      label: (
        <div className="flex-s-c" onClick={() => setLang('id')}>
          Bahasa Indonesia
        </div>
      )
    },
    {
      key: 'pl',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pl')}>
          Polski
        </div>
      )
    } */
  ].filter((item: any) => canLang && canLang.includes(item.key))

  
  const lang: any  = window.localStorage.getItem('lang')
  
  
  /* const _linkArr = longer ? [
    ...standardNav,
    ...moreArr
  ] : linkArr */
   const _linkArr = longer ? [
    ...allNav
  ] : linkArr

  const toHome = () => {
    navigate('/home')
  }
  const navigateTo = (url: string) => {
    if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
      navigate(url)
    }else {
      navigate('/login')
    }
  }
  const toMobilePage = () => {
    localStorage.removeItem('preferDesktop')
    if(commonStore.mobile_page === '1') {
      window.location.href = origin.includes('localhost') ? 'http://localhost:3000/#/' : origin + '/h5_index.html#/'
    }else {
      window.location.href = origin.includes('localhost') ? 'http://localhost:3000/' : origin
    }
  }
  const toAddRequirement = () => {
    if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
      setAsstInfo({})
      setAsstShow(true)
    }else {
      navigate('/login')
    }
  }


  const sxHeader = useMemo(() => {
    let key = isMobile ? 'xcx' : 'web'
    let keySxData = sxSetData[key] ? sxSetData[key] : {}
    let langSxData = keySxData[lang] ? keySxData[lang] : []
    let headerIndex = langSxData.findIndex((ele: any) => ele.key === 'header')
    if(headerIndex !== -1) {
      let headerItem = langSxData[headerIndex]
      let style = headerItem.style
      return <HeaderComponent headerInfo={headerItem}/> 
    }else {
      return null
    }
  }, [sxSetData, lang, isMobile])
  return (
    <>
      {
        pageType === '10' ? sxHeader : null
      }
      {
        pageType === '9' ? (
          <div className={styles['header9']}>
            <div className={styles['hb-boot']}>
              <div className={styles['ht-9']}>
                <div className={styles['ht-l']}>
                  {
                    token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo'] + ' pointer'}>
                      <LogoImg style={{maxWidth: 170, maxHeight: 40}}/>
                    </div> : <div className={styles['header-logo'] + ' pointer'} onClick={toHome}>
                      <img src={logo || ""} alt="" />
                    </div>
                  }
                </div>
                <div className={styles['ht-m']}>
                  <ConfigProvider
                    theme={{
                      token: {
                        /* 这里是你的全局 token */
                        colorBorder: colorPrimary,
                      },
                    }}
                  >
                    <VinInput
                      placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '请输入OE/零件名称搜索'}) : intl.formatMessage({id: '搜索'})}
                      size="large"
                      width={580}
                      wrapStyle={{marginRight: 10, marginLeft: 10}}
                      style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: colorPrimary, borderRadius: 6}}
                      classNames={{
                        input: hasFreeVin ? styles['mqp-page-input'] : styles['mqp-page-input-2']
                      }}
                      value={vinInputKey}
                      cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                      enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: colorPrimary}}></Button>}
                      canSearchOe={true}
                    />
                  </ConfigProvider>
                </div>
                <div className={styles['ht-r']}>
                  {/* {
                    localStorage.getItem('token') && (!localStorage.getItem('tourist_user')) ? <div className={styles['icon-btn']}>
                      <IMChat 
                        userInfo={commonStore.userInfo} 
                        title={intl.formatMessage({id: '聊天'})} 
                        enterButton={
                          <div className={styles['icon-btn-con']} style={{marginLeft: 0}}>
                            <i className='iconfont icon-Chat1' style={{fontSize: 24}}></i>
                            <span>{intl.formatMessage({id: '聊天'})}</span>
                          </div>
                        }
                      />
                    </div> : <div className={styles['icon-btn']} onClick={() => navigate('/login')}>
                      <i className='iconfont icon-Chat1' style={{fontSize: 24}}></i>
                      <span>{intl.formatMessage({id: '聊天'})}</span>
                    </div>
                  } */}
                  <div className={styles['icon-btn']} onClick={() => toAddRequirement()}>
                    <i className='iconfont icon-tianjiaxuqiu' style={{fontSize: 24}}></i>
                    <span>{intl.formatMessage({id: '需求'})}</span>
                  </div>
                  <div className={styles['icon-btn']} onClick={() => navigateTo('/epc')}>
                    <i className='iconfont icon-a-Frame7' style={{fontSize: 24}}></i>
                    <span>{intl.formatMessage({id: 'EPC'})}</span>
                  </div>
                  <div className={styles['icon-btn']} onClick={() => navigateTo('/mine/order')}>
                    <i className='iconfont icon-geren' style={{fontSize: 24}}></i>
                    <span>{intl.formatMessage({id: '个人'})}</span>
                  </div>
                  <Dropdown menu={{ items: langItems }}>
                    <div className={styles['icon-btn']}>
                      <i className='iconfont icon-En-01' style={{fontSize: 24}}></i>
                      <span>
                        { lang === 'zh' ? '中文' 
                          : lang === 'en' ? 'English' 
                          : lang === 'ru' ? 'Русский язык' 
                          : lang === 'cht' ? '中文-繁體' 
                          : lang === 'tr' ? 'Türkiye' 
                          : lang === 'ara' ? 'بالعربية' 
                          : lang === 'pt' ? 'Português'
                          : lang === 'vie' ? 'Tiếng Việt' 
                          : lang === 'fra' ? 'French'
                          : lang === 'kor' ? '한국어' : '中文' }
                      </span>
                    </div>
                  </Dropdown>
                  
                </div>
              </div>
            </div>
            <div className={styles['hb-9']}>
              <div className={styles['nav-list']} style={{background: colorPrimary}}>
                <div className={styles['hb-nav-wrap']} style={{width: lang === 'zh' ? 1140 : (classList.length > 6 ? 1104 : 1140), maxWidth: lang === 'zh' ? '100%' : (classList.length > 6 ? 'calc(100% - 36px)' : '100%')}}>
                  <div className={styles['hb-nav-list']} id="hb-nav-list">
                    <div className={pathname === '/home' && !selClass ? `${styles['nav-item']} ${styles['active']}` : styles['nav-item']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => navigate('/home')} id="navPath0">{intl.formatMessage({id: '首页'})}</div>
                    {
                      classList.map((item: any, index: number) => {
                        return (
                          <div  key={index} className={styles['classNav-item'] + " " + `${selClass === item ? styles['active'] : ''}`} id={`navPath${index + 1}`} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => classItemClick(item, index)}>
                            {capitalizeFirstLetter(item)}
                          </div>
                        )
                      })
                    }
                  </div>
                  
                </div>
                {
                  lang !== 'zh' && classList.length > 6 ? <Dropdown
                    menu={{ items: classItems }}
                  >
                    <div className={styles['nav-item']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                      <i className="icon iconfont icon-gengduo3"/>
                    </div>
                  </Dropdown> : null
                }
              </div>
              {
                hasSecondClass && selClass ? <div className={styles['subNav-list']}>
                  <div className={styles['hb-wrap']}>
                    {
                      (groupClass[selClass] || []).map((str: string, i: number) => {
                        return (
                          <div key={i} className={styles['nav-subtab'] + " pointer " + `${selClass && secondClass === str ? styles['active'] : ''}`} style={{color: selClass && secondClass === str ? colorPrimary : '#333333'}} onClick={() => gotoClass({ title: selClass + ',' + str })}>{capitalizeFirstLetter(str)}</div>
                        )
                      })
                    }
                  </div>
                </div> : null
              }
            </div>
          </div>
        ) : null
      }
      {
        pageType === '8' ? (
          <div className={styles['mqp-header']}  >
            <div className={styles['mqp-header-t'] + ' plr30 flex-b-c'} style={{ background: '#F2F2F2' }}>
              <div className={styles['mqp-header-l'] + ' flex-s-c'}>
                {
                  _linkArr.map((item: any, index: number) => {
                    if(item.is_add || item.path === '/cjh' || item.path === '/oe') return null
                    return (
                      <div onClick={() => {
                        goToUrl(item)
                      }} className={'mr30 pointer ' + `${pathname.indexOf(item.path) !== -1 ? 'p-color b' : ''}`}>{item.name}</div>
                    )
                  })
                }
              </div>
              <div className={styles['mqp-header-r'] + ' flex-s-c'}>
                {/* {
                  isMobile ? <div className="flex-s-c mr30 pointer" onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
                } */}
                {
                  token && (!localStorage.getItem('tourist_user')) ? (
                    <div className={'pointer'} onClick={() => toGo('/cart')}>{intl.formatMessage({ id: '购物车' })}({commonStore.cartNum})</div>
                  ): null
                }
                <Dropdown menu={{ items: langItems }}>
                  <div className={'pointer ml30'}>
                    { lang === 'zh' ? '中文' 
                        : lang === 'en' ? 'English' 
                        : lang === 'ru' ? 'Русский язык' 
                        : lang === 'cht' ? '中文-繁體' 
                        : lang === 'tr' ? 'Türkiye' 
                        : lang === 'ara' ? 'بالعربية' 
                        : lang === 'pt' ? 'Português'
                        : lang === 'vie' ? 'Tiếng Việt' 
                        : lang === 'fra' ? 'French'
                        : lang === 'kor' ? '한국어' : '中文' }
                  </div>
                </Dropdown>
                {
                  token && (!localStorage.getItem('tourist_user')) ? <div className="flex-s-c ml30 pointer">
                    <i className="iconfont icon-a-wo1 mr5"/>
                    <Dropdown menu={{ items: centerItems.filter((it: any) => !isCst || !it.cstnot) }}>
                      <div className="flex-s-c">
                        {userInfo.wechat_nick || userInfo.phone}
                        <i className="iconfont icon-down ml5" />
                      </div>
                    </Dropdown>
                  </div> : <div className="flex-s-c ml30 pointer" onClick={() => toCenterUrl('/login')}>
                    {intl.formatMessage({ id: '登录/注册' })}
                  </div>
                }
              </div>
            </div>
            {
              !pathname.includes('/epc') ? (
                <div className={styles['mqp-header-b'] + ' flex-c-c'}>
                  {
                    token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo'] + ' pointer'}>
                      <LogoImg style={{maxWidth: 150, maxHeight: 40}}/>
                    </div> : <div className={styles['header-logo'] + ' pointer'} onClick={toHome}>
                      <img src={logo || ""} alt="" />
                    </div>
                  }
                  <ConfigProvider
                    theme={{
                      token: {
                        /* 这里是你的全局 token */
                        colorBorder: colorPrimary,
                      },
                    }}
                  >
                    <VinInput
                      placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '请输入OE/车架号/零件名称搜索'}) : intl.formatMessage({id: '搜索'})}
                      size="large"
                      width={750}
                      wrapStyle={{marginRight: 10, marginLeft: 10}}
                      style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: colorPrimary, borderRadius: 6}}
                      classNames={{
                        input: hasFreeVin ? styles['wkt-page-input'] : styles['wkt-page-input-2']
                      }}
                      value={vinInputKey}
                      cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                      enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: 'rgba(255, 255, 255, 0.8)'}}></Button>}
                      hasFreeVin={true}
                      canSearchOe={true}
                      freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '107px', left: lang === 'ara' ? '107px' : 'unset'}}
                      ismqp={true}
                    />
                  </ConfigProvider>
                  {
                    token ? <ExportinOe/> : null
                  }
                </div>
              ): null
            }
          </div>
        ): null
      }
      {
        pageType === '7' ? <div className={styles['header']} style={{ height: 120, background: colorPrimary }}>
          <div className={styles['header-title-2'] + ' flex-c-c'}>
            <div className={styles['header-pop']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>{commonStore.headerInfo && commonStore.headerInfo.pop ? commonStore.headerInfo.pop : ''}</div>
            <div className={styles['header-center'] + ' flex-s-c'}>
              {
                isMobile ? <div className="flex-s-c mr30 pointer" onClick={toMobilePage} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>{intl.formatMessage({id: '手机版'})}</div> : null
              }
              <div className="flex-s-c" >
                <Dropdown menu={{ items: langItems }}>
                  <div className={styles['lang'] + ' flex-s-c pointer'} style={{ color: fontColorPrimary ? fontColorPrimary : '#ffffff' }}>
                    {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                    { lang === 'zh' ? '中文' 
                      : lang === 'en' ? 'English' 
                      : lang === 'ru' ? 'Русский язык' 
                      : lang === 'cht' ? '中文-繁體' 
                      : lang === 'tr' ? 'Türkiye' 
                      : lang === 'ara' ? 'بالعربية' 
                      : lang === 'pt' ? 'Português'
                      : lang === 'vie' ? 'Tiếng Việt' 
                      : lang === 'fra' ? 'French'
                      : lang === 'kor' ? '한국어' : '中文' }
                  </div>
                </Dropdown>
              </div>
              {
                token && (!localStorage.getItem('tourist_user')) ? <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                  <i className="iconfont icon-a-wo1 mr5"/>
                  <Dropdown menu={{ items: centerItems.filter((it: any) => !isCst || !it.cstnot) }}>
                    <div className="flex-s-c">
                      {userInfo.wechat_nick || userInfo.phone}
                      <i className="iconfont icon-down ml5" />
                    </div>
                  </Dropdown>
                </div> : <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/login')}>
                  <i className="iconfont icon-a-wo1 mr5"/>
                  {intl.formatMessage({ id: '登录/注册' })}
                </div>
              }
              {
                token && (!localStorage.getItem('tourist_user')) && commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/mine/order')}>
                  <i className="iconfont icon-wodedingdan mr5" />
                  {intl.formatMessage({id: '我的订单'})}
                </div> : null
              }
              {
                distributorInfo.status ? (
                  <div className='flex-s-c'>
                    <div onClick={() => navigate("/mine/invitation")} className={styles['invitation-code'] + ' flex-s-c ml30 pointer'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                      <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                      {intl.formatMessage({ id: '邀请码' })}
                    </div>
                    {
                      userInfo.is_repair_shop_admin ? (
                        <div className={'pointer flex-s-c ml30'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => openNew()}>
                          <i className="iconfont icon-a-Group21471 mr10"/>
                          {intl.formatMessage({ id: '商户后台' })}
                        </div>
                      ): null
                    }
                  </div>
                ): null
              }
            </div>
          </div>
          <div className={styles['header-wrap']}>
            <div className={styles['header-search'] + ' flex-s-c'} style={{padding: '0 20px'}}>
              <div className={styles['logo-6']}>
                {
                  token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo']}>
                    <LogoImg style={{maxWidth: 80, maxHeight: 48}}/>
                  </div> : <div className={styles['header-logo']} onClick={toHome}>
                    <img src={logo || ""} alt="" />
                  </div>
                }
              </div>
              <div style={{position: 'relative'}} className={styles['header-input-7']}>
                <ConfigProvider
                  theme={{
                    components: {
                      Input: {
                        /* 这里是你的组件 token */
                        activeBg: '#ffffff',
                        activeBorderColor: '#ffffff',
                        hoverBg: '#ffffff',
                        hoverBorderColor: '#ffffff'
                      },
                    },
                    token: {
                      /* 这里是你的全局 token */
                      colorBorder: 'rgba(255, 255, 255, 0.8)',
                    },
                  }}
                >
                  <VinInput
                    placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '车架号/品牌名称/OE/编码/零件名称'}) : intl.formatMessage({id: '搜索'})}
                    width={680}
                    wrapStyle={{marginRight: 10, marginLeft: 80}}
                    style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: 'rgba(255, 255, 255, 0.8)', borderRadius: 6, height: 36}}
                    classNames={{
                      input: hasFreeVin ? styles['page-input'] : styles['page-input-2']
                    }}
                    value={vinInputKey}
                    cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset', top: '9px' }}
                    enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70, height: 36, borderColor: 'rgba(255, 255, 255, 0.8)'}}></Button>}
                    hasFreeVin={true}
                    canSearchOe={true}
                    freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '107px', left: lang === 'ara' ? '107px' : 'unset', top: '6px'}}
                  />
                </ConfigProvider>
              </div>
              
              {
                token && (!localStorage.getItem('tourist_user')) ? <div className={styles['cart-btn-7'] + ' flex-c-c'} onClick={() => toGo('/cart')}>
                  <div className='flex-s-c'>
                    <Badge count={commonStore.cartNum}>
                      <i className="iconfont icon-a-gouwucheman2" style={{fontSize: 20, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
                    </Badge>
                    <span className="ml10" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>{intl.formatMessage({id: '购物车'})}</span>
                  </div>
                </div> : null
              }
            </div>
            <div className={styles['link-nav-wrap'] + ' flex-c-c'}>
              <div className={styles['link-nav-7'] + ' flex-s-c'}>
                {
                  classList.length ? <div className={styles['cate-boot'] + ' mr30'}>
                    <div ref={buttonRef} className={styles['cate-icon']} onClick={() => cateIconClick()}>
                      <span className="iconfont icon-liebiao" style={{fontSize: 14}}></span>
                      <span className="ml5">{intl.formatMessage({id: '产品分类'})}</span>
                    </div>
                    {
                      classShow ? <div ref={modalRef} className={styles['class-wrap'] + ' flex-s-c'}>
                        <div className={styles['class-list']}>
                          {
                            classList.map((item: any, index: number) => {
                              return (
                                <div  key={index}  className={styles['categories-tab'] + " pointer " + `${selClass === item ? styles['active'] : ''}`} onClick={() => {setSelClass(item);}}>
                                  <div className={styles['categories-img']}>
                                    <img src={classImg[item] ? classImg[item] : 'https://cdns.007vin.com/img/autorepair/cst/no_item.png'} alt="" />
                                  </div>
                                  <div>
                                    <div className={styles['title']}>{capitalizeFirstLetter(item)}</div>
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                        {
                          hasSecondClass && selClass ? <div className={styles['second-wrap']} style={{height: `${classList.length * 36 + 10}px`}}>
                            <div onClick={() => gotoClass({title: selClass})} className={styles['categories-subtab'] + " pointer" + ` ${selClass && !secondClass ? styles['active'] : ''}`}>{intl.formatMessage({ id: '全部' })}</div>
                            {
                              (groupClass[selClass] || []).map((str: string, i: number) => {
                                return (
                                  <div key={i} className={styles['categories-subtab'] + " pointer " + `${selClass && secondClass === str ? styles['active'] : ''}`} onClick={() => gotoClass({ title: selClass + ',' + str })}>{capitalizeFirstLetter(str)}</div>
                                )
                              })
                            }
                          </div> : null
                        }
                      </div> : null
                    }
                  </div> : null
                }
                
                {
                  (lang === 'zh' || lang === 'cht') && moreArr.length < 5 ? <>
                    {
                      linkArr.map((link: any, index: any) => {
                        return (
                          link.key ? null : <Fragment key={index}>
                            {
                              link.path === '/cjh' || link.path === '/oe' || link.path === '/home' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'raba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? 'bold' : '400'}} key={index} onClick={() => goToUrl(link)}>
                                {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                              </div>
                            }
                          </Fragment>
                        )
                      })
                    }
                    {
                      moreArr.map((link: any, index: number) => {
                        return (
                          <Fragment key={index}>
                            <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? 'bold' : '400'}} key={index} onClick={() => goMore(link)}>
                              {link.name}
                            </div>
                          </Fragment>
                        )
                      })
                    }
                  </> : linkArr.map((link: any, index: any) => {
                    if(link.key) {
                      let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                      return (
                        <Fragment key={index}>
                          <Dropdown menu={{ 
                            items: moreArr.map((item: any) => {
                              return {
                                key: item.path,
                                label: <div className='flex-s-c' onClick={() => goMore(item)}>
                                  <i className={'iconfont mr5 ' + item.icon}/>
                                  {item.name}
                                </div>
                              }
                            }) 
                          }}
                          >
                            <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '' }`} key={index} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? 'bold' : '400'}}>
                              {
                                nowItem ? <i className={'iconfont mr5 ' + nowItem.icon}/> : <i className={'iconfont mr5 ' + link.icon}/>
                              }
                              {nowItem ? nowItem.name : link.name}
                              <CaretDownOutlined className="ml5" />
                            </div>
                          </Dropdown>
                        </Fragment>
                        
                      )
                    }
                    return (
                      <Fragment key={index}>
                        {
                          link.path === '/cjh' || link.path === '/oe' || link.path === '/home' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? 'bold' : '400'}} key={index} onClick={() => goToUrl(link)}>
                            {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                          </div>
                        }
                      </Fragment>
                    )
                  })
                }
              </div>
            </div>
            
          </div>
          
        </div> : null
      }
      {
        pageType === '6' ? <div className={styles['header']} style={{ height: 190, background: colorPrimary }}>
          <div className={styles['header-title'] + ' flex-c-c'}>
            {
              token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo']}>
                <LogoImg style={{maxWidth: 150, maxHeight: 70}}/>
              </div> : <div className={styles['header-logo']} onClick={toHome}>
                <img src={logo || ""} alt="" />
              </div>
            }
            <div className={styles['header-center'] + ' flex-s-c'}>
              {
                isMobile ? <div className="flex-s-c mr30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
              }
              <div className="flex-s-c" >
                <Dropdown menu={{ items: langItems }}>
                  <div className={styles['lang'] + ' flex-s-c pointer'} style={{ color: fontColorPrimary ? fontColorPrimary : '#ffffff' }}>
                    {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                    { lang === 'zh' ? '中文' 
                      : lang === 'en' ? 'English' 
                      : lang === 'ru' ? 'Русский язык' 
                      : lang === 'cht' ? '中文-繁體' 
                      : lang === 'tr' ? 'Türkiye' 
                      : lang === 'ara' ? 'بالعربية' 
                      : lang === 'pt' ? 'Português'
                      : lang === 'vie' ? 'Tiếng Việt'
                      : lang === 'fra' ? 'French'
                      : lang === 'kor' ? '한국어' : '中文' }
                  </div>
                </Dropdown>
              </div>
              {
                token && (!localStorage.getItem('tourist_user')) ? <div className="flex-s-c ml30 pointer">
                  <i className="iconfont icon-a-wo1 mr5" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}/>
                  <Dropdown menu={{ items: centerItems.filter((it: any) => !isCst || !it.cstnot) }}>
                    <div className="flex-s-c" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                      {userInfo.wechat_nick || userInfo.phone}
                      <i className="iconfont icon-down ml5" />
                    </div>
                  </Dropdown>
                </div> : <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/login')}>
                  <i className="iconfont icon-a-wo1 mr5"/>
                  {intl.formatMessage({ id: '登录/注册' })}
                </div>
              }
              {
                token && (!localStorage.getItem('tourist_user')) && commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/mine/order')}>
                  <i className="iconfont icon-wodedingdan mr5" />
                  {intl.formatMessage({id: '我的订单'})}
                </div> : null
              }
              {
                distributorInfo.status ? (
                  <div className='flex-s-c'>
                    <div onClick={() => navigate("/mine/invitation")} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} className={styles['invitation-code'] + ' flex-s-c ml30 pointer'}>
                      <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                      {intl.formatMessage({ id: '邀请码' })}
                    </div>
                    {
                      userInfo.is_repair_shop_admin ? (
                        <div className={'pointer flex-s-c ml30'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => openNew()}>
                          <i className="iconfont icon-a-Group21471 mr10"/>
                          {intl.formatMessage({ id: '商户后台' })}
                        </div>
                      ): null
                    }
                  </div>
                ): null
              }
            </div>
          </div>
          <div className={styles['header-wrap']} style={{padding: '0 20px'}}>
            <div className='flex-s-c'>
              {
                classList.length ? <div className={styles['cate-boot']}>
                  <div ref={buttonRef} className={styles['cate-btn'] + ' flex-b-c'} onClick={() => setClassShow(!classShow)}>
                    <span className={styles['cate-msg']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>{selClass ? capitalizeFirstLetter(selClass) : intl.formatMessage({id: '分类'})}{selClass && secondClass ? '-' : ''}{selClass && secondClass ? capitalizeFirstLetter(secondClass) : ''}</span>
                    <span className='flex-s-c'>
                      {
                        selClass ? <CloseOutlined style={{fontSize: 14, color: fontColorPrimary ? fontColorPrimary : '#ffffff', cursor: 'pointer', marginRight: lang === 'ara' ? 0 : 5, marginLeft: lang === 'ara' ? 5 : 0}} onClick={e => delSelClass(e)}/> : null
                      }
                      {
                        classShow ? <UpOutlined style={{fontSize: 12, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/> : <DownOutlined style={{fontSize: 12, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
                      }
                    </span>
                  </div>
                  {
                    classShow ? <div ref={modalRef} className={styles['class-wrap'] + ' flex-s-c'}>
                      <div className={styles['class-list']} style={{minHeight: '285px'}}>
                        {
                          classList.map((item: any, index: number) => {
                            return (
                              <div  key={index}  className={styles['categories-tab'] + " pointer " + `${selClass === item ? styles['active'] : ''}`} onClick={() => {setSelClass(item);}}>
                                <div className={styles['categories-img']}>
                                  <img src={classImg[item] ? classImg[item] : 'https://cdns.007vin.com/img/autorepair/cst/no_item.png'} alt="" />
                                </div>
                                <div>
                                  <div className={styles['title']}>{capitalizeFirstLetter(item)}</div>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                      {
                        hasSecondClass && selClass ? <div className={styles['second-wrap']} style={{height: `${classList.length * 36 + 10}px`, minHeight: '285px'}}>
                          <div onClick={() => gotoClass({title: selClass})} className={styles['categories-subtab'] + " pointer" + ` ${selClass && !secondClass ? styles['active'] : ''}`}>{intl.formatMessage({ id: '全部' })}</div>
                          {
                            (groupClass[selClass] || []).map((str: string, i: number) => {
                              return (
                                <div key={i} className={styles['categories-subtab'] + " pointer " + `${selClass && secondClass === str ? styles['active'] : ''}`} onClick={() => gotoClass({ title: selClass + ',' + str })}>{capitalizeFirstLetter(str)}</div>
                              )
                            })
                          }
                        </div> : null
                      }
                    </div> : null
                  }
                </div> : null
              }
              {
                isXts || isHm ? (
                  <div style={{position: 'relative'}} className={styles['header-input-6'] + ' flex-s-c'}>
                    <ConfigProvider
                      theme={{
                        components: {
                          Input: {
                            /* 这里是你的组件 token */
                            activeBg: '#ffffff',
                            activeBorderColor: '#ffffff',
                            hoverBg: '#ffffff',
                            hoverBorderColor: '#ffffff'
                          },
                        },
                        token: {
                          /* 这里是你的全局 token */
                          colorBorder: 'rgba(255, 255, 255, 0.8)',
                        },
                      }}
                    >
                      <VinInput
                        placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '车架号/品牌名称/OE/编码/零件名称'}) : intl.formatMessage({id: '搜索'})}
                        size="large"
                        width={600}
                        wrapStyle={{marginRight: 10, marginLeft: 10}}
                        style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: 'rgba(255, 255, 255, 0.8)', borderRadius: 6}}
                        classNames={{
                          input: hasFreeVin ? styles['page-input'] : styles['page-input-2']
                        }}
                        value={vinInputKey}
                        cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                        enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: 'rgba(255, 255, 255, 0.8)'}}></Button>}
                        hasFreeVin={true}
                        canSearchOe={true}
                        freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '107px', left: lang === 'ara' ? '107px' : 'unset'}}
                      />
                      {
                        token ? (
                          <ExportinOe 
                            btnStyle={{ 
                              background: 'rgba(255, 255, 255, 0.8)', 
                              color: colorPrimary 
                            }} 
                            qStyle={{ color: '#fff' }}
                          />
                        ): null
                      }
                    </ConfigProvider>
                  </div>
                ): (
                  <div style={{position: 'relative'}} className={styles['header-input-6']}>
                    <ConfigProvider
                      theme={{
                        components: {
                          Input: {
                            /* 这里是你的组件 token */
                            activeBg: '#ffffff',
                            activeBorderColor: '#ffffff',
                            hoverBg: '#ffffff',
                            hoverBorderColor: '#ffffff'
                          },
                        },
                        token: {
                          /* 这里是你的全局 token */
                          colorBorder: 'rgba(255, 255, 255, 0.8)',
                        },
                      }}
                    >
                      <VinInput
                        placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '车架号/品牌名称/OE/编码/零件名称'}) : intl.formatMessage({id: '搜索'})}
                        size="large"
                        width={750}
                        wrapStyle={{marginRight: 10, marginLeft: 10}}
                        style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: 'rgba(255, 255, 255, 0.8)', borderRadius: 6}}
                        classNames={{
                          input: hasFreeVin ? styles['page-input'] : styles['page-input-2']
                        }}
                        value={vinInputKey}
                        cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                        enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: 'rgba(255, 255, 255, 0.8)'}}></Button>}
                        hasFreeVin={true}
                        canSearchOe={true}
                        freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '107px', left: lang === 'ara' ? '107px' : 'unset'}}
                      />
                    </ConfigProvider>
                  </div>
                )
              }
              
              
              {
                token && (!localStorage.getItem('tourist_user')) ? <div className={styles['cart-btn'] + ' flex-b-c'} onClick={() => toGo('/cart')}>
                  <div className='flex-s-c'>
                    <Badge count={commonStore.cartNum}>
                      <i className="iconfont icon-a-gouwucheman2" style={{fontSize: 20, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
                    </Badge>
                    <span className={styles['cart-price']}>{priceUnit}{commonStore.cartPrice}</span>
                  </div>
                  <RightOutlined style={{fontSize: 12, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
                </div> : null
              }
            </div>
            <div className={styles['link-nav'] + ' flex-s-c'}>
              {
                parts_categories_zone.length > 0 ? linkArr.map((link: any, index: any) => {
                  if(link.key) {
                    let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                    return (
                      <Fragment key={index}>
                        <Dropdown menu={{ 
                          items: moreArr.map((item: any) => {
                            return {
                              key: item.path,
                              label: <div className='flex-s-c' onClick={() => goMore(item)}>
                                <i className={'iconfont mr5 ' + item.icon}/>
                                {item.name}
                              </div>
                            }
                          }) 
                        }}
                        >
                          <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '' }`} key={index} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? '500' : '400'}}>
                            {
                              nowItem ? <i className={'iconfont mr5 ' + nowItem.icon}/> : <i className={'iconfont mr5 ' + link.icon}/>
                            }
                            {nowItem ? nowItem.name : link.name}
                            <CaretDownOutlined className="ml5" />
                          </div>
                        </Dropdown>
                      </Fragment>
                      
                    )
                  }
                  return (
                    <Fragment key={index}>
                      {
                        link.path === '/cjh' || link.path === '/oe' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                          {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                        </div>
                      }
                    </Fragment>
                  )
                }) : (
                  (lang === 'zh' || lang === 'cht' || lang === 'en') ? <>
                    {
                      linkArr.map((link: any, index: any) => {
                        return (
                          link.key ? null : <Fragment key={index}>
                            {
                              link.path === '/cjh' || link.path === '/oe' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                                {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                              </div>
                            }
                          </Fragment>
                        )
                      })
                    }
                    {
                      moreArr.length < 7 ? moreArr.map((link: any, index: number) => {
                        return (
                          <Fragment key={index}>
                            <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                              {link.name}
                            </div>
                          </Fragment>
                        )
                      }) : <Fragment>
                        {
                          moreArr.slice(0, 5).map((link: any, index: number) => {
                            return (
                              <Fragment key={index}>
                                <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                                  {link.name}
                                </div>
                              </Fragment>
                            )
                          })
                        }
                        <Dropdown menu={{ 
                          items: moreArr.slice(5).map((item: any) => {
                            return {
                              key: item.path,
                              label: <div className='flex-s-c' onClick={() => goMore(item)}>
                                <i className={'iconfont mr5 ' + item.icon}/>
                                {item.name}
                              </div>
                            }
                          }) 
                        }}
                        >
                          <div className={styles['link'] + ' ' + `${ _nowItem ? styles['active'] : '' }`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: _nowItem ? '500' : '400'}}>
                            {
                              _nowItem ? <i className={'iconfont mr5 ' + _nowItem.icon}/> : null
                            }
                            {_nowItem ? _nowItem.name : intl.formatMessage({id: '更多'})}
                            <CaretDownOutlined className="ml5" />
                          </div>
                        </Dropdown>
                      </Fragment>
                    }
                  </> : <>
                    {
                      linkArr.map((link: any, index: any) => {
                        return (
                          link.key ? null : <Fragment key={index}>
                            {
                              link.path === '/cjh' || link.path === '/oe' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                                {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                              </div>
                            }
                          </Fragment>
                        )
                      })
                    }
                    {
                      moreArr.length < 4 ? moreArr.map((link: any, index: number) => {
                        return (
                          <Fragment key={index}>
                            <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                              {link.name}
                            </div>
                          </Fragment>
                        )
                      }) : <Fragment>
                        {
                          moreArr.slice(0, 2).map((link: any, index: number) => {
                            return (
                              <Fragment key={index}>
                                <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                                  {link.name}
                                </div>
                              </Fragment>
                            )
                          })
                        }
                        <Dropdown menu={{ 
                          items: moreArr.slice(2).map((item: any) => {
                            return {
                              key: item.path,
                              label: <div className='flex-s-c' onClick={() => goMore(item)}>
                                <i className={'iconfont mr5 ' + item.icon}/>
                                {item.name}
                              </div>
                            }
                          }) 
                        }}
                        >
                          <div className={styles['link'] + ' ' + `${ _nowItem ? styles['active'] : '' }`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: _nowItem ? '500' : '400'}}>
                            {
                              _nowItem ? <i className={'iconfont mr5 ' + _nowItem.icon}/> : null
                            }
                            {_nowItem ? _nowItem.name : intl.formatMessage({id: '更多'})}
                            <CaretDownOutlined className="ml5" />
                          </div>
                        </Dropdown>
                      </Fragment>
                    }
                  </>
                )
              }
              <span className={styles['link-vertical'] + ' mr30'}></span>
              {
                (lang === 'zh' || lang === 'cht' || lang === 'en') ? 
                  (
                    parts_categories_zone.length < 7 ? parts_categories_zone.map((item: any, index: number) => {
                    let config = item.config ? item.config : {}
                    let img = config[lang] && config[lang].img ? config[lang].img : ''
                    return (
                      <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                        {capitalizeFirstLetter(item.name)}
                      </div>
                    )
                  }) : <Fragment>
                    {
                      parts_categories_zone.slice(0, 5).map((item: any, index: number) => {
                        let config = item.config ? item.config : {}
                        let img = config[lang] && config[lang].img ? config[lang].img : ''
                        return (
                          <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                            {capitalizeFirstLetter(item.name)}
                          </div>
                        )
                      })
                    }
                    <Dropdown 
                      menu={{ 
                        items: parts_categories_zone.slice(5).map((item: any) => {
                          return {
                            key: item.path,
                            label: <div className='flex-s-c' onClick={() => gotoTagClass(item)}>
                              {capitalizeFirstLetter(item.name)}
                            </div>
                          }
                        }) 
                      }}
                    >
                      <div className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass ? '500' : '400'}}>
                        {pathname === '/cjh' && selHeaderClass ? capitalizeFirstLetter(selHeaderClass) : intl.formatMessage({id: '更多分类'})}
                        <CaretDownOutlined className="ml5" />
                      </div>
                    </Dropdown>
                  </Fragment>
                ) : (
                  parts_categories_zone.length < 4 ? parts_categories_zone.map((item: any, index: number) => {
                    let config = item.config ? item.config : {}
                    let img = config[lang] && config[lang].img ? config[lang].img : ''
                    return (
                      <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                        {capitalizeFirstLetter(item.name)}
                      </div>
                    )
                  }) : <Fragment>
                    {
                      parts_categories_zone.slice(0, 2).map((item: any, index: number) => {
                        let config = item.config ? item.config : {}
                        let img = config[lang] && config[lang].img ? config[lang].img : ''
                        return (
                          <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                            {capitalizeFirstLetter(item.name)}
                          </div>
                        )
                      })
                    }
                    <Dropdown 
                      menu={{ 
                        items: parts_categories_zone.slice(2).map((item: any) => {
                          return {
                            key: item.path,
                            label: <div className='flex-s-c' onClick={() => gotoTagClass(item)}>
                              {capitalizeFirstLetter(item.name)}
                            </div>
                          }
                        }) 
                      }}
                    >
                      <div className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass ? '500' : '400'}}>
                        {pathname === '/cjh' && selHeaderClass ? capitalizeFirstLetter(selHeaderClass) : intl.formatMessage({id: '更多分类'})}
                        <CaretDownOutlined className="ml5" />
                      </div>
                    </Dropdown>
                  </Fragment>
                )
              }
            </div>
          </div>
        </div> : null
      }
      {
        pageType === '5' ? <div className={styles['header']} style={{ height: 140, background: colorPrimary }}>
          <div className={styles['header-t']} style={{backgroundColor: 'rgba(0, 0, 0, 0.2)', height: 30, color: fontColorPrimary ? fontColorPrimary : '#fff', fontSize: 12}}>
            <div></div>
            <div className="flex-s-c">
              {
                isMobile ? <div style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} className="flex-s-c mr30 pointer" onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
              }
              <div className="flex-s-c" >
                <Dropdown menu={{ items: langItems }}>
                  <div className={styles['lang'] + ' flex-s-c pointer'} style={{ color: fontColorPrimary ? fontColorPrimary : '#ffffff' }}>
                    {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                    { lang === 'zh' ? '中文' 
                      : lang === 'en' ? 'English' 
                      : lang === 'ru' ? 'Русский язык' 
                      : lang === 'cht' ? '中文-繁體' 
                      : lang === 'tr' ? 'Türkiye' 
                      : lang === 'ara' ? 'بالعربية' 
                      : lang === 'pt' ? 'Português'
                      : lang === 'vie' ? 'Tiếng Việt'
                      : lang === 'fra' ? 'French'
                      : lang === 'kor' ? '한국어' : '中文' }
                  </div>
                </Dropdown>
              </div>
              {
                token && (!localStorage.getItem('tourist_user')) ? <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                  <i className="iconfont icon-a-wo1 mr5"/>
                  <Dropdown menu={{ items: centerItems.filter((it: any) => !isCst || !it.cstnot) }}>
                    <div className="flex-s-c" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                      {userInfo.wechat_nick || userInfo.phone}
                      <i className="iconfont icon-down ml5" />
                    </div>
                  </Dropdown>
                </div> : <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/login')}>
                  <i className="iconfont icon-a-wo1 mr5"/>
                  {intl.formatMessage({ id: '登录/注册' })}
                </div>
              }
              {
                token && (!localStorage.getItem('tourist_user')) && commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/mine/order')}>
                  <i className="iconfont icon-wodedingdan mr5" />
                  {intl.formatMessage({id: '我的订单'})}
                </div> : null
              }
              {
                 distributorInfo.status ? (
                  <div className='flex-s-c'>
                    <div onClick={() => navigate("/mine/invitation")} className={styles['invitation-code'] + ' flex-s-c ml30 pointer'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                      <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                      {intl.formatMessage({ id: '邀请码' })}
                    </div>
                    {
                      userInfo.is_repair_shop_admin ? (
                        <div className={'pointer flex-s-c ml30'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => openNew()}>
                          <i className="iconfont icon-a-Group21471 mr10"/>
                          {intl.formatMessage({ id: '商户后台' })}
                        </div>
                      ): null
                    }
                  </div>
                ): null
              }
            </div>
          </div>
          <div className={styles['header-b']} style={{ backgroundColor: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#FFFFFF', height: 90, paddingTop: 20 }}>
            <div className='flex-c-c' style={{minWidth: 1140, margin: '0 auto', width: 'calc(100% - 100px)'}}>
              {
                token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['logo-wrap']}>
                  <LogoImg style={{maxWidth: 150, maxHeight: 70}}/>
                </div> : <div className={styles['logo-wrap']}>
                  <img src={logo || ""} alt="" onClick={toHome} />
                </div>
              }
              <div className="ml40 mt20">
                <div className={styles['header-vin-input'] + " flex-s-c"}>
                  <div style={{position: 'relative'}} className={styles['header-input-5']}>
                    <ConfigProvider
                      theme={{
                        components: {
                          Input: {
                            /* 这里是你的组件 token */
                            activeBg: colorPrimary,
                            activeBorderColor: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)',
                            hoverBg: colorPrimary,
                            hoverBorderColor: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)'
                          },
                        },
                        token: {
                          /* 这里是你的全局 token */
                          colorBorder: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)',
                        },
                      }}
                    >
                      <VinInput
                        placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '车架号/品牌名称/OE/编码/零件名称'}) : intl.formatMessage({id: '搜索'})}
                        size="large"
                        width={660}
                        style={{background: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#ffffff', borderColor: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)'}}
                        classNames={{
                          input: hasFreeVin ? styles['page-input'] : styles['page-input-2']
                        }}
                        value={vinInputKey}
                        cameraButtonStyle={{ color: fontColorPrimary ? fontColorPrimary : '#ffffff', right: lang === 'ara' ? 'unset' : '100px', left: lang === 'ara' ? '100px' : 'unset' }}
                        enterButton={<Button type="primary" style={{background: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#FFFFFF', width: 88, borderColor: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)'}} icon={<SearchOutlined/>}>
                          {intl.formatMessage({id: '搜索'})}
                        </Button>}
                        hasFreeVin={true}
                        canSearchOe={true}
                        freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '130px', left: lang === 'ara' ? '130px' : 'unset', color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}
                      />
                    </ConfigProvider>
                    
                  </div>
                  {
                    commonStore.headerInfo && commonStore.headerInfo.model_checked ? <Button type="primary" size="large" style={{background: colorPrimary, minWidth: 110, borderColor: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)', marginLeft: lang === 'ara' ? 0 : 10, marginRight: lang === 'ara' ? 10 : 0}} onClick={() => setBrandOpen(true)}>{intl.formatMessage({id: '车型选择'})}</Button> : null
                  }
                  {
                    token && (!localStorage.getItem('tourist_user')) ? (
                      <Button type="primary" style={{background: colorPrimary, minWidth: 140, borderColor: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.8)', marginLeft: lang === 'ara' ? 0 : 20, marginRight: lang === 'ara' ? 20 : 0}} size="large" icon={<i className="iconfont icon-a-gouwucheman2"/>}  onClick={() => toGo('/cart')}>
                        {intl.formatMessage({ id: '购物车' })}({commonStore.cartNum})
                      </Button>
                    ): null
                  }
                </div>
                <div className={styles['links']} style={{marginTop: 5}}>
                  {
                    _linkArr.map((link: any, index: any) => {
                      if(link.key) {
                        let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                        return (
                          <Fragment key={index}>
                            <Dropdown menu={{ 
                              items: moreArr.map((item: any) => {
                                return {
                                  key: item.path,
                                  label: <div className='flex-s-c' onClick={() => goMore(item)}>
                                    <i className={'iconfont mr5 ' + item.icon}/>
                                    {item.name}
                                  </div>
                                }
                              }) 
                            }}
                            >
                              <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '' }`} key={index} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? '500' : '400'}}>
                                {
                                  nowItem ? <i className={'iconfont mr5 ' + nowItem.icon}/> : <i className={'iconfont mr5 ' + link.icon}/>
                                }
                                {nowItem ? nowItem.name : link.name}
                                <CaretDownOutlined className="ml5" />
                              </div>
                            </Dropdown>
                          </Fragment>
                          
                        )
                      }
                      return (
                        <Fragment key={index}>
                          {
                            pageType === '5' && link.path === '/cjh' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                              {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                            </div>
                          }
                          {
                            pageType === '4' ? <span className={styles['link-vertical']}></span> : null
                          }
                        </Fragment>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div> : null
      }
      {
        pageType !== '5' && pageType !== '6' && pageType !== '7' && pageType !== '8' && pageType !== '9' && pageType !== '10' ? <div className={styles['header']} style={{ height: pageType === '1' ? 150 : pageType === '2' ? 70 : (pageType === '4' ? 105 : 150) }}>
          {
            pageType === '1' || pageType === '3' || pageType === '4' ? (
              <>
                <div className={styles['header-t']} style={{ backgroundColor: pageType === '4' ? colorPrimary : '#fff', color: pageType === '4' ? (fontColorPrimary ? fontColorPrimary : '#fff') : '#333', height: pageType === '4' ? '60px' : '105px'}}>
                  {
                    token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <LogoImg style={{height: pageType === '3' ? 100 : 40}}/> : <img src={logo || ""} alt="" style={{height: pageType === '3' ? 100 : 40 }} onClick={toHome} />
                  }
                  <div className={styles['tr']}>
                    <div className="flex-s-c" style={{ flexDirection: 'row-reverse' }}>
                      {
                        token && (!localStorage.getItem('tourist_user')) ? (
                          <div className="flex-s-c pointer"  onClick={() => toGo('/cart')}>
                            <i className="iconfont icon-a-gouwucheman2 mr5"/>
                            {intl.formatMessage({ id: '购物车' })}({commonStore.cartNum})
                          </div>
                        ): null
                      }
                      <div className="flex-s-c mr30 pointer"  onClick={() => checkUrl() }>
                        <i className="iconfont icon-a-wo1 mr5"/>
                        {
                          token && (!localStorage.getItem('tourist_user')) ? (
                            <>
                              {userInfo.wechat_nick || userInfo.phone}
                            </>
                          ): <>{intl.formatMessage({ id: '请登录' })}</>
                        }
                        <i className="iconfont icon-down ml5" />
                      </div>
                      <div className="flex-s-c" >
                        <Dropdown menu={{ items: langItems }}>
                          <div className={styles['lang'] + ' flex-s-c mr30 pointer'} style={{ color: pageType === '4' ? (fontColorPrimary ? fontColorPrimary : '#ffffff') : '#333333' }}>
                            {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                            { lang === 'zh' ? '中文' 
                            : lang === 'en' ? 'English' 
                            : lang === 'ru' ? 'Русский язык' 
                            : lang === 'cht' ? '中文-繁體' 
                            : lang === 'tr' ? 'Türkiye' 
                            : lang === 'ara' ? 'بالعربية' 
                            : lang === 'pt' ? 'Português'
                            : lang === 'vie' ? 'Tiếng Việt'
                            : lang === 'fra' ? 'French'
                            : lang === 'kor' ? '한국어' : '中文' }
                          </div>
                        </Dropdown>
                      </div>
                      {
                        distributorInfo.status ? (
                          <div className='flex-s-c'>
                            <div onClick={() => navigate("/mine/invitation")} className={styles['invitation-code'] + ' flex-s-c mr20 pointer'}>
                              <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                              {intl.formatMessage({ id: '邀请码' })}
                            </div>
                            {
                              userInfo.is_repair_shop_admin ? (
                                <div className={'pointer flex-s-c mr20'} onClick={() => openNew()}>
                                  <i className="iconfont icon-a-Group21471 mr10"/>
                                  {intl.formatMessage({ id: '商户后台' })}
                                </div>
                              ): null
                            }
                          </div>
                        ): null
                      }
                      {
                        isMobile ? <div className="flex-s-c mr30 pointer" onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
                      }
                    </div>
                  </div>
                </div>
                <div className={styles['header-b']} style={{ backgroundColor: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#FFFFFF' }}>
                  <div className={styles['links']}>
                    {
                      _linkArr.map((link: any, index: any) => {
                        if(link.key) {
                          let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                          
                          return (
                            <Fragment key={index}>
                              <Dropdown menu={{ 
                                items: moreArr.map((item: any) => {
                                  return {
                                    key: item.path,
                                    label: <div onClick={() => goMore(item)}>{item.name}</div>
                                  }
                                }) 
                              }}
                              >
                                <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '' }`} key={index} style={{borderRight: pageType === '4' ? 'none' : '1px solid #8E8E8E', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? '500' : '400'}}>
                                  {nowItem ? nowItem.name : link.name}
                                  <CaretDownOutlined className="ml5" />
                                </div>
                              </Dropdown>
                              {
                                pageType === '4' ? <span className={styles['link-vertical']}></span> : null
                              }
                            </Fragment>
                            
                          )
                        }
                        return (
                          <Fragment key={index}>
                            <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: pageType === '4' ? 'none' : '1px solid #8E8E8E', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                              {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : null}{link.name}
                              
                            </div>
                            {
                              pageType === '4' ? <span className={styles['link-vertical']}></span> : null
                            }
                          </Fragment>
                        )
                      })
                    }
                  </div>
                  {/* <div className="flex-s-c" >
                    <Dropdown menu={{ items: langItems }}>
                      <div className={styles['lang'] + ' flex-s-c mr30 pointer'}>
                        <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} />
                        { lang === 'zh' ? '中文' : lang === 'en' ? 'English' : lang === 'ru' ? 'Русский язык' : lang === 'cht' ? '中文-繁體' : '中文'  }
                      </div>
                    </Dropdown>
                  </div> */}
                </div>
              </>
            ): (
              <div  className={styles['type2']}  style={{ backgroundColor: colorPrimary ? colorPrimary : '#096BED' }}>
                <div className={styles['left']}>
                  {
                    token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <LogoImg/> : <img className={styles['logo']} src={logo || ""} alt="" onClick={toHome} />
                  }
                  {
                    _linkArr.map((link: any, index: number) => {
                      if(link.key) {
                        let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                        return (
                          <Dropdown
                          key={index} 
                          menu={{ 
                            items: moreArr.map((item: any) => {
                              return {
                                key: item.path,
                                label: <div onClick={() => goMore(item)}>{item.name}</div>
                              }
                            }) 
                          }}
                          >
                            <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '#ffffff' }`} style={{backgroundColor: nowItem ? colorPrimary : 'transparent', borderColor: nowItem ? (fontColorPrimary ? fontColorPrimary : '#ffffff') : 'transparent', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? '500' : '400'}} key={index} >
                              {nowItem ? nowItem.name : link.name}
                              <CaretDownOutlined className="ml5" />
                            </div>
                          </Dropdown>
                        )
                      }
                      if(!link.path) return null
                      return (
                        <div key={index} className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{backgroundColor: pathname.indexOf(link.path) === 0 ? colorPrimary : 'transparent', borderColor: pathname.indexOf(link.path) === 0 ? '#ffffff' : 'transparent', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} onClick={() => goToUrl(link)}>{link.name}</div>
                      )
                    })
                  }
                  
                </div>
                <div className={styles['right']} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)'}}>
                  {
                    isMobile ? <div className="flex-s-c mr30 pointer" onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
                  }
                  {
                    distributorInfo.status ? (
                      <div className='flex-s-c'>
                        <div onClick={() => navigate("/mine/invitation")} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} className={styles['invitation-code'] + ' flex-s-c mr20 pointer'}>
                          <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                          {intl.formatMessage({ id: '邀请码' })}
                        </div>
                        {
                          userInfo.is_repair_shop_admin ? (
                            <div className={'pointer flex-s-c mr20'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFF'}} onClick={() => openNew()}>
                              <i className="iconfont icon-a-Group21471 mr10"/>
                              {intl.formatMessage({ id: '商户后台' })}
                            </div>
                          ): null
                        }
                      </div>
                    ): null
                  }
                  
                  <Dropdown menu={{ items: langItems }}>
                    <div className={styles['lang'] + ' flex-s-c mr20 pointer'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                      {/* <i className="iconfont icon-a-yuyan11 mr5 " /> */}
                      {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                      { lang === 'zh' ? '中文' 
                      : lang === 'en' ? 'English' 
                      : lang === 'ru' ? 'Русский язык' 
                      : lang === 'cht' ? '中文-繁體' 
                      : lang === 'tr' ? 'Türkiye' 
                      : lang === 'ara' ? 'بالعربية' 
                      : lang === 'pt' ? 'Português'
                      : lang === 'vie' ? 'Tiếng Việt'
                      : lang === 'fra' ? 'French'
                      : lang === 'kor' ? '한국어' : '中文' }
                    </div>
                  </Dropdown>
                  {
                    token && (!localStorage.getItem('tourist_user')) ? (
                      <div className="flex-s-c  pointer"  onClick={() => goToMain()}>
                        <i  className="iconfont icon-a-wo1"/>
                        <span className="mlr5">{userInfo.wechat_nick || userInfo.phone}</span>
                        <i className="iconfont icon-down" />
                      </div>
                    ): (
                      <>
                        <Button onClick={() => navigate('/login')} className={styles['nologin-btn'] + " mr10"} type="primary" ghost style={{background: fontColorPrimary ? fontColorPrimary : '#FFFFFF', color: colorPrimary }}>{intl.formatMessage({ id: '登录' })}</Button>
                        <Button onClick={() => navigate('/register')} className={styles['nologin-btn']} type="primary" ghost style={{background: fontColorPrimary ? fontColorPrimary : '#FFFFFF', color: colorPrimary }}>{intl.formatMessage({ id: '注册' })}</Button>
                      </>
                    )
                  }
                </div>
              </div>
            )
          }
        </div> : null
      }
      <Modal
        open={brandOpen}
        onCancel={() => setBrandOpen(false)}
        footer={null}
        width={1200}
        wrapClassName={styles['car-brand-search']}
      >
        <Carsearch
          from='vinInput'
          carInfo={carInfo}
          setCarInfo={setCarInfo}
          setOpen={setBrandOpen}
        />
      </Modal>

      {/* 需求 */}
      {
        asstShow ? (
          <PurchaseAsstModal
            open={asstShow}
            info={asstInfo}
            onCancel={() => {setAsstShow(false); setAsstInfo({});}}
          />
        ) : null
      }

    </>
  )
}


const LogoImg: React.FC<any> = observer((props) => {
  const { maxWidth, maxHeight, style } = props
  const { pathname } = useLocation()
  const intl = useIntl()
  const navigate = useNavigate()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { logo } = commonStore
  const { store, nim } = useStateContext();

  const [api, contextHolder] = notification.useNotification();
  const [enableV2CloudConversation, setEnableV2CloudConversation] = useState<boolean>(sessionStorage.getItem("enableV2CloudConversation") ? sessionStorage.getItem("enableV2CloudConversation") == "true" : false)

  const isJSON = (str: string) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  const unreadMsgsCount = useMemo(() => {
    if (enableV2CloudConversation) {
      // 云端会话
      return store.conversationStore?.totalUnreadCount;
    } else {
      // 本地会话
      return store.localConversationStore?.totalUnreadCount;
    }
  }, [
    enableV2CloudConversation,
    store.conversationStore?.totalUnreadCount,
    store.localConversationStore?.totalUnreadCount,
  ]);

  useEffect(() => {
    const onMsg = (msgs: any) => {
      console.log("sider msg:", msgs)
      let msg = msgs[msgs.length - 1]
      let msgTextObjMsg = msg.content && isJSON(msg.content) ? JSON.parse(msg.content) : {}
      let msgTextObj = msgTextObjMsg.msg && isJSON(msgTextObjMsg.msg) ? JSON.parse(msgTextObjMsg.msg) : {}
      let isFromOrder = msgTextObj.notice_type && (msgTextObj.notice_type === 'refund' || msgTextObj.notice_type === 'order_quote_finished' || msgTextObj.notice_type === 'order_wait_send' || msgTextObj.notice_type === 'user_verify') ? true : false
      if(isFromOrder) {
        setCommonStore({
          type: 'msgNoticeData',
          value: msg
        })
        openNotification(msgTextObj)
      }
    }
    nim.V2NIMNotificationService.on('onReceiveCustomNotifications', onMsg)
    return () => {
      nim.V2NIMNotificationService.off('onReceiveCustomNotifications', onMsg)
    }
  }, [nim, unreadMsgsCount])
  
  useEffect(() => {
    if(nim && store.connectStore) {
      if(store.connectStore.connectStatus === 0) {
        setCommonStore({type:'isOperate',value:false})
      }
      if(store.connectStore.connectStatus && store.connectStore.connectStatus === 1) {
        setCommonStore({type:'isOperate',value:true})
      }
    }
  }, [store.connectStore, nim])

  

  const openNotification = (data: any) => {
		if(data.notice_type === 'refund') {
		  const key = `open${Date.now()}`;
		  const btn = (
		    <Button 
					type="primary" 
					onClick={() => {
						api.destroy();
						if(pathname === '/mine/aftersales/detail') {
							window.location.reload()
						}else {
							navigate(`/mine/aftersales/detail?merchant_id=${data.merchant_id}&inquiry_id=${data.inquiry_id}&refund_id=${data.refund_id}`)
						}
					}}>
					{intl.formatMessage({ id: '查看详情' })}
				</Button>
		  );
		  let refund_status = data.refund_status
		  let message;
		  if(refund_status === 1) {
		    message = intl.formatMessage({ id: '售后订单商家已同意！' })
		  }else {
		    message = intl.formatMessage({ id: '售后订单商家已拒绝！' })
		  }
		  api.open({
		    message: message,
		    duration: null,
		    description:(
		      <div>
		        <div className="mt10">
							{intl.formatMessage({ id: '创建时间' })}:{data.create_time}
						</div>
						<div className="mt10">
              {intl.formatMessage({ id: '处理时间' })}:{data.send_time}
						</div>
		      </div>
		    ),
		    btn,
		    key,
		    // onClose: close,
		  });
		}
    if(data.notice_type === 'order_quote_finished' || data.notice_type === 'order_wait_send') {
      const key = `open${Date.now()}`;
      const btn = (
        <Button type="primary" onClick={
					() => {
						if(window.location.pathname === '/mine/order/detail') {
						  window.location.reload()
						}else {
						  api.destroy(); 
							navigate(`/mine/order/detail?merchant_id=${data.merchant_id}&inquiry_id=${data.enquiry_info.enquiry_id}`)
						}
					}
				}
				>{intl.formatMessage({ id: '查看详情' })}</Button>
      );
      let inquiry_status = data.inquiry_status
      let car_info = data.car_info 
      let message;
      if(inquiry_status === 5) {
        message = intl.formatMessage({ id: '订单已报价，请尽快处理！' })
      }else {
        message = intl.formatMessage({ id: '订单已发货，请注意查收！' })
      }
      if(inquiry_status > 5 && inquiry_status !== 11) {
        api.open({
          message: message,
          duration: null,
          description:(
            <div>
              {
                car_info ? (
                  <div className="flex-s-c">
                    {car_info.brand_logo ? <img style={{ height: 20, border: '1px solid #f6f6f6' }} src={car_info.brand_logo} /> : ''}
                    {car_info.market_name}
                  </div>
                ): null
              }
              <div className="mt20">{intl.formatMessage({ id: '创建时间' })}：{data.order_create_time}</div>
              {
                inquiry_status === 5 ? (
                  <div className="mt10">{intl.formatMessage({ id: '报价时间' })}：{data.quote_time}</div>
                ): inquiry_status === 8 ? (
                  <div className="mt10">{intl.formatMessage({ id: '发货时间' })}：{data.send_time}</div>
                ): null
              }
            </div>
          ),
          btn,
          key,
          // onClose: close,
        });
      }
      
    }
    if(data.notice_type === 'user_verify') {
      const key = `open${Date.now()}`;
      const btn = (
        <Button type="primary" onClick={() => {
          if(window.location.pathname === '/mine/company') {
            window.location.reload()
          }else {
            api.destroy(); navigate(`/mine/company`)
          }
        }
        }>{intl.formatMessage({ id: '前往处理' })}</Button>
      );
      let phone = data.phone
      let _phone = phone.slice(-4)
      let message = intl.formatMessage({id: '尾号{phone}用户，提交了认证审核！'}, {phone: _phone})
      let time = data.create_time
      api.open({
        message: intl.formatMessage({ id: '审核单' }),
        duration: null,
        description:(
          <div>
            <div style={{color: '#333333', fontSize: 14}}>{message}</div>
            <div style={{marginTop: 8, color: '#888888', fontSize: 14}}>{time}</div>
          </div>
        ),
        btn,
        key,
        // onClose: close,
      });
    }
  };
  const toHome = () => {
    navigate('/home')
  }
  return (
    <>
      {contextHolder}
      <img className={styles['logo']} style={style} src={logo || ""} alt="" onClick={toHome} />
    </>
    
  )
})


export default Header